export default {
  label: {
    time: 'Search by time',
    orderNo: 'Search by orderNo',
    amount: 'amount',
    channelCode: ' channel Code',
    channelType: 'channel Type',
    createAcct: 'create Acct',
    createTime: 'create Time',
    id: 'Primary key ID',
    merchantNo: ' merchantNo',
    merchantOrderNo: 'Merchant order',
    status: '	trading status',
    systemOrderNo: 'SystemNo',
    BeginTime: 'Start and end time',
    serviceType: 'Service type',

    accountNumber: 'Receiving account',
    currency: 'Currency	',
    extra: 'Extra parameters	',
    message: 'Order message	',
    notifyUrl: 'Order callback address',
    remark: 'note	',
    sign: 'sign	',
    updateAcct: 'Modify account',
    updateTime: 'update Time',
    userIP: `Paying user's IP`
  },
  rules: {
    amount: 'Amount cannot be empty',
    channelCode: 'Channel code must be selected',
    channelType: 'Channel type must be selected',
    createAcct: 'The creator account cannot be empty',
    createTime: 'Creation time must be selected',
    id: 'Primary key ID cannot be empty',
    merchantNo: 'Merchant ID cannot be empty',
    merchantOrderNo: 'Merchant order cannot be empty',
    status: '	Transaction status must be selected',
    systemOrderNo: 'The system order number cannot be empty',
    BeginTime: 'Start and end time must be selected',
    serviceType: 'he type of service must be selected'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/transaction.js